var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrediant1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2062,
    height: 1780,
    viewBox: "0 0 2062 1780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_2514_43211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.656 1003.42C833.36 1003.42 969.312 859.832 969.312 682.709C969.312 505.586 833.36 362 665.656 362C497.951 362 362 505.586 362 682.709C362 859.832 497.951 1003.42 665.656 1003.42Z",
    fill: "#FF6D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.89 1330.75C1171.6 1330.75 1307.55 1187.16 1307.55 1010.04C1307.55 832.914 1171.6 689.327 1003.89 689.327C836.19 689.327 700.239 832.914 700.239 1010.04C700.239 1187.16 836.19 1330.75 1003.89 1330.75Z",
    fill: "#FEBE58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.159 1418.73C832.864 1418.73 968.815 1275.14 968.815 1098.02C968.815 920.893 832.864 777.306 665.159 777.306C497.455 777.306 361.503 920.893 361.503 1098.02C361.503 1275.14 497.455 1418.73 665.159 1418.73Z",
    fill: "#DE2BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.84 1175.7C1564.54 1175.7 1700.5 1032.11 1700.5 854.991C1700.5 677.868 1564.54 534.282 1396.84 534.282C1229.14 534.282 1093.18 677.868 1093.18 854.991C1093.18 1032.11 1229.14 1175.7 1396.84 1175.7Z",
    fill: "#24EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.523 1280.64C1066.23 1280.64 1202.18 1137.05 1202.18 959.928C1202.18 782.805 1066.23 639.218 898.523 639.218C730.818 639.218 594.867 782.805 594.867 959.928C594.867 1137.05 730.818 1280.64 898.523 1280.64Z",
    fill: "#ADFF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2514_43211",
    x: 0.408417,
    y: 0.904999,
    width: 2061.18,
    height: 1778.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 180.548,
    result: "effect1_foregroundBlur_2514_43211"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrediant1);
export default __webpack_public_path__ + "static/media/grediant1.d14cd106a226ac0293ef958840180dc5.svg";
export { ForwardRef as ReactComponent };